export default __webpack_public_path__ + "locales/el-GR/SMTPSettings.json?hash=6233cb684bc19b2270a3868d493159e0";